var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgYouTube = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M21.1818182,15.6037999 C21.1818182,18.7272727 18.0485333,18.7272727 18.0485333,18.7272727 L6.13221586,18.7272727 C3,18.7272727 3,15.6037999 3,15.6037999 L3,9.12347286 C3,6 6.13221586,6 6.13221586,6 L18.0485333,6 C21.1818182,6 21.1818182,9.12347286 21.1818182,9.12347286 L21.1818182,15.6037999 Z M15.6207988,12.3726945 L9.66851963,8.88689457 L9.66851963,15.8574288 L15.6207988,12.3726945 Z"
  }));
};
export default SvgYouTube;